export default __webpack_public_path__ + "static/media/swipeA.fdefac0c.svg";